/**
 * @generated SignedSource<<01d52e5f1927125cfccb74b5115e46f2>>
 * @relayHash a4f5d4385a960ee5454e75dd04c77124
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 785a868e77c08c408f1539a7e53378631833fb446450c92ea34477ae9ee0a39a

import type { ConcreteRequest } from 'relay-runtime';
export type queryAgentMentionsForInitialStateQuery$variables = {
  cloudId: string;
  first?: number | null;
  includeMyAgents: boolean;
  includeRovoChatAgent: boolean;
  product?: string | null;
};
export type queryAgentMentionsForInitialStateQuery$data = {
  readonly allAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly favoriteAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly myAgents?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
  readonly verifiedAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly creatorType: string | null;
        readonly description: string | null;
        readonly id: string;
        readonly identityAccount: {
          readonly picture: AGG$URL;
        } | null;
        readonly identityAccountId: string | null;
        readonly name: string | null;
      } | null;
    }>;
  } | null;
};
export type queryAgentMentionsForInitialStateQuery = {
  response: queryAgentMentionsForInitialStateQuery$data;
  variables: queryAgentMentionsForInitialStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeMyAgents"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeRovoChatAgent"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "includeRovoChatAgent",
  "variableName": "includeRovoChatAgent"
},
v4 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v5 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "fields": [
      (v3/*: any*/),
      {
        "kind": "Literal",
        "name": "onlyFavouriteAgents",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "creatorType"
},
v8 = {
  "kind": "ScalarField",
  "name": "description"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  }
],
v13 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "fields": [
      (v3/*: any*/),
      {
        "kind": "Literal",
        "name": "onlyMyAgents",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v4/*: any*/)
],
v14 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "fields": [
      (v3/*: any*/),
      {
        "kind": "Literal",
        "name": "onlyVerifiedAgents",
        "value": true
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v4/*: any*/)
],
v15 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "fields": [
      (v3/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "input"
  },
  (v4/*: any*/)
],
v16 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v9/*: any*/),
              (v6/*: any*/)
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "queryAgentMentionsForInitialStateQuery",
    "selections": [
      {
        "alias": "favoriteAgents",
        "args": (v5/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v12/*: any*/)
      },
      {
        "condition": "includeMyAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "myAgents",
            "args": (v13/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v12/*: any*/)
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v14/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v12/*: any*/)
      },
      {
        "alias": "allAgents",
        "args": (v15/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v12/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queryAgentMentionsForInitialStateQuery",
    "selections": [
      {
        "alias": "favoriteAgents",
        "args": (v5/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v16/*: any*/)
      },
      {
        "condition": "includeMyAgents",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "myAgents",
            "args": (v13/*: any*/),
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": (v16/*: any*/)
          }
        ]
      },
      {
        "alias": "verifiedAgents",
        "args": (v14/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v16/*: any*/)
      },
      {
        "alias": "allAgents",
        "args": (v15/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v16/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "a4f5d4385a960ee5454e75dd04c77124",
    "id": "785a868e77c08c408f1539a7e53378631833fb446450c92ea34477ae9ee0a39a",
    "metadata": {},
    "name": "queryAgentMentionsForInitialStateQuery",
    "operationKind": "query",
    "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$includeMyAgents:Boolean!,$includeRovoChatAgent:Boolean!,$product:String){favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},myAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyMyAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@include(if:$includeMyAgents)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true,includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{includeRovoChatAgent:$includeRovoChatAgent},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,creatorType,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
  }
};
})();

(node as any).hash = "a935aeddd94745b63d0399837d1a0bac";

export default node;
